import { Button, Modal } from "react-bootstrap";
import { FormInput } from "../../../components/forms";

const EditAddressModal = ({ address, setAddress, onFieldChanged, isUpdating }) => {
    const { address1, address2, address3, address4, address5 } = address || {};

    // Trim whitespace and commas before sending to server
    const editAddressPart = (part, newValue) => onFieldChanged(part, (newValue ?? "").trim().replace(/^,+|,+$/g, ''));

    return <Modal
        show={address != null}
        onHide={() => setAddress(null)}
        centered
        backdrop="static"
    >
        <Modal.Header>
            <Modal.Title>Edit Address Parts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <FormInput
                label="Address Line 1"
                value={address1}
                onBlur={(newValue) => editAddressPart('address1', newValue)}
            />
            <FormInput
                parentClassName="pt-2"
                label="Line 2"
                value={address2}
                onBlur={(newValue) => editAddressPart('address2', newValue)}
            />
            <FormInput
                parentClassName="pt-2"
                label="Line 3"
                value={address3}
                onBlur={(newValue) => editAddressPart('address3', newValue)}
            />
            <FormInput
                parentClassName="pt-2"
                label="Line 4"
                value={address4}
                onBlur={(newValue) => editAddressPart('address4', newValue)}
            />
            <FormInput
                parentClassName="pt-2"
                label="Line 5"
                value={address5}
                onBlur={(newValue) => editAddressPart('address5', newValue)}
            />
        </Modal.Body>
        <Modal.Footer>
            <Button variant="light" onClick={() => setAddress(null)} disabled={isUpdating}>
                Close
            </Button>
        </Modal.Footer>
    </Modal>
}

export default EditAddressModal;